import React from "react";
import "./CtaBanner.css";

const CtaBanner: React.FC = () => {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="cta-banner">
      <div className="cta-banner__container">
        <div className="cta-banner__glow" />
        <h2 className="cta-banner__title">
          Need help <span className="cta-banner__title--accent">hiring</span>?
        </h2>
        <p className="cta-banner__desc">
          Tell us who you're looking for — we'll take it from here.
        </p>
        <button className="cta-banner__btn" onClick={scrollToContact}>
          Start Hiring Today
          <span className="cta-banner__btn-arrow">→</span>
        </button>
      </div>
    </section>
  );
};

export default CtaBanner;
